<template>
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <!-- Card de Sucesso (Exibido apenas após o envio) -->
        <div v-if="exibirMsgSucesso" class="card-aviso-sucesso">
          <div class="card-icon">
            <span>&#10004;</span>
          </div>
          <div class="card-texto">
            <h2>Relato Enviado!</h2>
            <p>Sua contribuição foi registrada com sucesso. Obrigado por nos ajudar a melhorar o Legisla Goiás!</p>
          </div>
        </div>

        <!-- Formulário (Escondido após o envio) -->
        <template v-else>
          <div class="modal-header">
            <div class="titulo-pagina">
              <div class="triangulo-play"></div>
              <h1>Enviar mensagem</h1>
            </div>
            <button class="modal-close-button" @click="$emit('close')">&times;</button>
          </div>

          <div class="modal-body">
            <div class="info-legislacao" v-if="legislacao">
              <p><strong>Referência:</strong> {{ labelLegislacao }}</p>
            </div>

            <form @submit.prevent="enviar">
              <div class="cad-erro" v-if="erroEnviando">
                <p><span> &#10008;</span> {{ erroEnviando }}</p>
              </div>

              <div class="form-content">
                <p>
                  Utilize este formulário para registrar erros, elogios, comentários ou reclamações sobre esta norma.
                </p>

                <div class="linha-form">
                  <div class="item">
                    <label>Nome:</label>
                    <input type="text" v-model="form.nome" />
                  </div>
                  <div class="item">
                    <label><i>E-mail:</i></label>
                    <input type="email" v-model="form.email" />
                  </div>
                </div>
                <div class="info-contato">
                  <p>Para ser comunicado(a) das providências adotadas pela CASA CIVIL, infome seu nome e <i>e-mail</i>.</p>
                </div>

                <div class="item">
                  <label><span>*</span>Tipo de mensagem:</label>
                  <select v-model="form.ocorrencia_sugestoes" required>
                    <option :value="1">Comentário</option>
                    <option :value="2">Elogio</option>
                    <option :value="3">Erro</option>
                    <option :value="4">Sugestão</option>
                  </select>
                </div>

                <div class="item" v-if="exibirMensagemRevisaLegal">
                  <div class="alerta-revisa-legal">
                    Para propostas de revisão normativa, tais como alteração, revogação, e outras mudanças nas normas legais, utilize o REVISA LEGAL acessando <a href="https://revisa.go.gov.br/" target="_blank">https://revisa.go.gov.br/</a>
                  </div>
                </div>

                <div class="item">
                  <label><span>*</span>Texto (limite de 600 palavras):</label>
                  <textarea v-model="form.texto" rows="6" required></textarea>
                  <small :class="{ 'text-danger': palavrasRestantes < 0 }">
                    Palavras: {{ totalPalavras }}/600
                  </small>
                </div>

                <div class="modal-footer">
                  <button type="submit" class="btn-enviar" :disabled="enviando || totalPalavras > 600">
                    {{ enviando ? 'Enviando...' : 'Enviar' }}
                  </button>
                  <button type="button" class="btn-cancelar" @click="$emit('close')">Cancelar</button>
                </div>
              </div>
            </form>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SugestoesLegislacaoApi from "../../services/SugestoesLegislacaoApi";
import titleLegislacao from "../../helpers/legislacao/titleLegislacao";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export default {
  name: "RelatarErroModal",
  props: {
    legislacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviando: false,
      exibirMsgSucesso: false,
      erroEnviando: null,
      form: {
        nome: "",
        email: "",
        ocorrencia_sugestoes: 3, // Default Erro
        texto: "",
        legislacao_id: this.legislacao.id,
      },
    };
  },
  computed: {
    labelLegislacao() {
      if (this.legislacao.tipo_legislacao && this.legislacao.numero && this.legislacao.data_legislacao) {
        try {
          const dataFormatada = format(parseISO(this.legislacao.data_legislacao), "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
          return `${this.legislacao.tipo_legislacao.nome} nº ${this.legislacao.numero}, ${dataFormatada}`;
        } catch (e) {
          return titleLegislacao(this.legislacao);
        }
      }
      return titleLegislacao(this.legislacao);
    },
    totalPalavras() {
      if (!this.form.texto) return 0;
      return this.form.texto.trim().split(/\s+/).length;
    },
    palavrasRestantes() {
      return 600 - this.totalPalavras;
    },
    exibirMensagemRevisaLegal() {
      return (
        this.form.ocorrencia_sugestoes === 4 &&
        this.legislacao.ente_federativo &&
        this.legislacao.ente_federativo.id === 1
      );
    },
  },
  created() {
    this.sugestoesApi = new SugestoesLegislacaoApi();
  },
  mounted() {
    const norma = document.querySelector("norma-widget");
    if (norma) {
      norma.style.display = "none";
    }
  },
  destroyed() {
    const norma = document.querySelector("norma-widget");
    if (norma) {
      norma.style.display = "block";
    }
  },
  methods: {
    async enviar() {
      if (this.totalPalavras > 600) {
        alert("O texto não pode ultrapassar 600 palavras.");
        return;
      }

      try {
        this.enviando = true;
        this.erroEnviando = null;
        this.exibirMsgSucesso = false;

        await this.sugestoesApi.create(this.form);

        this.exibirMsgSucesso = true;
        
        setTimeout(() => {
          this.$emit('close');
        }, 3000);
      } catch (err) {
        console.error(err);
        this.erroEnviando = "Ocorreu um erro ao enviar o relato. Tente novamente mais tarde.";
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  max-width: 600px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: 90vh;
  overflow-y: auto;
}

.card-aviso-sucesso {
  padding: 3rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  .card-icon {
    width: 80px;
    height: 80px;
    background-color: #45b053;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    box-shadow: 0 4px 10px rgba(69, 176, 83, 0.3);
  }

  .card-texto {
    h2 {
      color: #115810;
      margin-bottom: 0.5rem;
      font-family: "Calibri-Bold";
    }
    p {
      color: #666;
      font-size: 1.1rem;
      line-height: 1.4;
    }
  }
}

.modal-header {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.modal-close-button {
  border: none;
  background: none;
  font-size: 2rem;
  cursor: pointer;
  color: #666;
  &:hover {
    color: #000;
  }
}

.modal-body {
  padding: 1.5rem;
  color: #000;
}

.modal-footer {
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

h1 {
  background-color: #ffb24e;
  color: #115810;
  margin: 0;
  border-left: #ffa900 solid 0.3rem;
  padding: 0.2rem 0.5rem;
  border-radius: 10px;
  display: inline-block;
  font-size: 1.2rem;
}

.titulo-pagina {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.triangulo-play {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 18px solid darkgreen;
}

.info-legislacao {
  background-color: #f8f9fa;
  padding: 0.8rem;
  border-radius: 0;
  margin-bottom: 1.2rem;
  border-left: 4px solid #115810;
  p {
    margin: 0;
    font-size: 0.95rem;
  }
}

.cad-erro {
  background-color: rgb(192, 0, 0);
  padding: 0.5rem;
  margin-bottom: 1rem;
  text-align: center;
  border-radius: 4px;
  p {
    color: white;
    margin: 0;
  }
}

.item {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  label {
    font-size: 0.9rem;
    margin-bottom: 0.3rem;
    span {
      color: red;
    }
  }
  input, select, textarea {
    padding: 0.5rem;
    border: 1px solid #083e07;
    border-radius: 0.2rem;
    font-family: inherit;
    font-size: 1rem;
  }
  small {
    margin-top: 0.2rem;
    font-size: 0.8rem;
  }
}

.info-contato {
  margin-bottom: 1rem;
  p {
    font-size: 0.85rem;
    color: #000000;
    font-weight: bold;
    margin-top: 0 !important;
  }
}

.alerta-revisa-legal {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  a {
    color: #856404;
    font-weight: bold;
    text-decoration: underline;
  }
}

.linha-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.btn-enviar {
  background-color: #115810;
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  border-radius: 0;
  font-weight: bold;
  border-radius: 1rem;
  cursor: pointer;
  min-width: 100px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.btn-cancelar {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  border-radius: 0;
  font-weight: bold;
  border-radius: 1rem;
  cursor: pointer;
  min-width: 100px;
}

@media (max-width: 600px) {
  .linha-form {
    grid-template-columns: 1fr;
  }
}
</style>
